import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAchievement, LazyBanner, LazyBannerBlock, LazyBannerWithIcon, LazyButton, LazyButtonAddToCalendar, LazyButtonDownload, LazyButtonFullWidth, LazyCard, LazyColumnElement, LazyColumnHeadingAndDescription, LazyContactRow, LazyCsvToJson, LazyDescriptionBlock, LazyEventCards, LazyFAQ, LazyFinancialReports, LazyFourColumns, LazyGrayBlock, LazyHeading, LazyHeadingAndDescription, LazyHorizontalTitleDescription, LazyImageBanner, LazyInvestorEvents, LazyLatestNewsAndAnnouncements, LazyLinkCard, LazyPastEvents, LazyPressBanner, LazyPressReleases, LazyProfileCard, LazyScopeAndAchievements, LazySideBySide, LazySingleFinancialReport, LazySlider, LazySocialMediaBlok, LazySocialMediaWrapper, LazyStatisticCard, LazyStatisticCardBlok, LazyStructuredFinancialReports, LazyStructuredFinancialReportsAccordionWrapper, LazyStructuredFinancialReportsGroup, LazyStructuredFinancialReportsGroups, LazySubscribeBlock, LazySubscribeBlockPopup, LazyThreeColumns, LazyTwoColumns, LazyUpcomingEvents, LazyVideoBanner, LazyBlockDivider, LazyContentHero, LazyHeroBanner, LazyHeroHeadingAndDescription, LazyCiRestrictedStaticPage, LazyCiStaticPage, LazyImageContent, LazyNuxtIcon } from '#components'
const lazyGlobalComponents = [
  ["Achievement", LazyAchievement],
["Banner", LazyBanner],
["BannerBlock", LazyBannerBlock],
["BannerWithIcon", LazyBannerWithIcon],
["Button", LazyButton],
["ButtonAddToCalendar", LazyButtonAddToCalendar],
["ButtonDownload", LazyButtonDownload],
["ButtonFullWidth", LazyButtonFullWidth],
["Card", LazyCard],
["ColumnElement", LazyColumnElement],
["ColumnHeadingAndDescription", LazyColumnHeadingAndDescription],
["ContactRow", LazyContactRow],
["CsvToJson", LazyCsvToJson],
["DescriptionBlock", LazyDescriptionBlock],
["EventCards", LazyEventCards],
["FAQ", LazyFAQ],
["FinancialReports", LazyFinancialReports],
["FourColumns", LazyFourColumns],
["GrayBlock", LazyGrayBlock],
["Heading", LazyHeading],
["HeadingAndDescription", LazyHeadingAndDescription],
["HorizontalTitleDescription", LazyHorizontalTitleDescription],
["ImageBanner", LazyImageBanner],
["InvestorEvents", LazyInvestorEvents],
["LatestNewsAndAnnouncements", LazyLatestNewsAndAnnouncements],
["LinkCard", LazyLinkCard],
["PastEvents", LazyPastEvents],
["PressBanner", LazyPressBanner],
["PressReleases", LazyPressReleases],
["ProfileCard", LazyProfileCard],
["ScopeAndAchievements", LazyScopeAndAchievements],
["SideBySide", LazySideBySide],
["SingleFinancialReport", LazySingleFinancialReport],
["Slider", LazySlider],
["SocialMediaBlok", LazySocialMediaBlok],
["SocialMediaWrapper", LazySocialMediaWrapper],
["StatisticCard", LazyStatisticCard],
["StatisticCardBlok", LazyStatisticCardBlok],
["StructuredFinancialReports", LazyStructuredFinancialReports],
["StructuredFinancialReportsAccordionWrapper", LazyStructuredFinancialReportsAccordionWrapper],
["StructuredFinancialReportsGroup", LazyStructuredFinancialReportsGroup],
["StructuredFinancialReportsGroups", LazyStructuredFinancialReportsGroups],
["SubscribeBlock", LazySubscribeBlock],
["SubscribeBlockPopup", LazySubscribeBlockPopup],
["ThreeColumns", LazyThreeColumns],
["TwoColumns", LazyTwoColumns],
["UpcomingEvents", LazyUpcomingEvents],
["VideoBanner", LazyVideoBanner],
["BlockDivider", LazyBlockDivider],
["ContentHero", LazyContentHero],
["HeroBanner", LazyHeroBanner],
["HeroHeadingAndDescription", LazyHeroHeadingAndDescription],
["CiRestrictedStaticPage", LazyCiRestrictedStaticPage],
["CiStaticPage", LazyCiStaticPage],
["ImageContent", LazyImageContent],
["NuxtIcon", LazyNuxtIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
